import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Phone, Mail, MapPin, Youtube } from "lucide-react";
import wittmannLogo from "@/assets/wittmann-logo.webp";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-foreground text-background">
      <div className="section-container py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 font-bold text-lg mb-4">
              <img src={wittmannLogo} alt="WITTMANN" className="h-8 w-auto" />
              <span>ROMANIA</span>
            </div>
            <p className="text-background/60 text-sm leading-relaxed">
              {t("footer.description")}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">{t("footer.quickLinks")}</h3>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background/60 hover:text-background transition-colors">{t("nav.home")}</Link>
              <Link to="/despre-noi" className="text-sm text-background/60 hover:text-background transition-colors">{t("nav.about")}</Link>
              <Link to="/echipamente" className="text-sm text-background/60 hover:text-background transition-colors">{t("nav.equipment")}</Link>
              <Link to="/contact" className="text-sm text-background/60 hover:text-background transition-colors">{t("nav.contact")}</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">{t("footer.contactInfo")}</h3>
            <div className="flex flex-col gap-3 text-sm text-background/60">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>Bulevardul Iuliu Maniu 7, corp C, 061102 București</span>
              </div>
              <div className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                <div className="space-y-1">
                  <div>
                    <p className="text-background/80 text-xs">Bogdan Nestor — Manager general</p>
                    <a href="tel:+40720227255" className="hover:text-background transition-colors">+4 0720 227 255</a>
                  </div>
                  <div>
                    <p className="text-background/80 text-xs">Eduard Lazea — Manager vânzări</p>
                    <a href="tel:+40725227255" className="hover:text-background transition-colors">+4 0725 227 255</a>
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                <div className="space-y-1">
                  <div>
                    <p className="text-background/80 text-xs">{t("footer.emailSales")}</p>
                    <span>comercial@wittmann-group.ro</span>
                  </div>
                  <div>
                    <p className="text-background/80 text-xs">{t("footer.emailService")}</p>
                    <span>service@wittmann-group.ro</span>
                  </div>
                  <div>
                    <p className="text-background/80 text-xs">{t("footer.emailEoat")}</p>
                    <span>eoat@wittmann-group.ro</span>
                  </div>
                </div>
              </div>
              <a
                href="https://www.youtube.com/@WittmannRomania"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-background transition-colors"
              >
                <Youtube className="w-4 h-4 shrink-0" />
                <span>YouTube</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background/10 mt-10 pt-6 text-center text-xs text-background/40">
          © {new Date().getFullYear()} WITTMANN ROMANIA. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
